import { type ReactNode } from 'react';
import styles from './ListItem.module.css';

interface ListItemProps {
  leading?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  trailing?: ReactNode;
  onClick?: () => void;
  variant?: 'light' | 'dark';
}

export function ListItem({
  leading,
  title,
  subtitle,
  trailing,
  onClick,
  variant = 'light',
}: ListItemProps): JSX.Element {
  const cls = `${styles.row} ${styles[`v_${variant}`]} ${onClick ? styles.clickable : ''}`;
  const inner = (
    <>
      {leading && <span className={styles.leading}>{leading}</span>}
      <span className={styles.text}>
        <span className={styles.title}>{title}</span>
        {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
      </span>
      {trailing && <span className={styles.trailing}>{trailing}</span>}
    </>
  );

  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={cls}>
        {inner}
      </button>
    );
  }
  return <div className={cls}>{inner}</div>;
}
